module.exports = "<input type=\"radio\" [name]=\"name\" (change)=\"onChange()\" [(ngModel)]=\"value\" [value]=\"defaultValue\">\r\n"